var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgProposal(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20 9.99958C20 8.64243 19.4045 7.36207 18.3945 6.55747C18.5113 5.20366 18.0275 3.87739 17.0684 2.9167C16.1092 1.95768 14.7873 1.47191 13.5012 1.61881C11.8215 -0.514564 8.1926 -0.554627 6.55206 1.5896C3.85563 1.26909 1.26262 3.80978 1.61792 6.48736C-0.513865 8.16835 -0.554733 11.7999 1.58873 13.4425C1.47197 14.7963 1.95571 16.1226 2.91484 17.0833C3.87398 18.0423 5.19759 18.5281 6.482 18.3812C8.16174 20.5146 11.7906 20.5546 13.4312 18.4104C14.7823 18.5264 16.1084 18.044 17.0684 17.0833C18.0267 16.1234 18.5104 14.7963 18.3653 13.5135C19.4045 12.6388 20 11.3584 20 10.0013V9.99958ZM6.65548 7.49562C6.66048 6.40389 8.31854 6.40389 8.32354 7.49562C8.31854 8.58735 6.66048 8.58735 6.65548 7.49562ZM9.01746 12.9668C8.76058 13.3532 8.23931 13.4517 7.86066 13.198C7.477 12.9426 7.37358 12.4243 7.62963 12.0403L10.9658 7.03238C11.221 6.64928 11.7381 6.54411 12.1226 6.80119C12.5062 7.05659 12.6096 7.57491 12.3536 7.95885L9.01746 12.9668ZM12.4937 13.3382C11.4028 13.3332 11.4028 11.6739 12.4937 11.6689C13.5846 11.6739 13.5846 13.3332 12.4937 13.3382Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProposal);
export default __webpack_public_path__ + "static/media/proposal.af0e3315293212073cae75d211ecb5e3.svg";
export { ForwardRef as ReactComponent };